import { render, staticRenderFns } from "./SFormGroup.vue?vue&type=template&id=144e22ce"
import script from "./SFormGroup.vue?vue&type=script&lang=js"
export * from "./SFormGroup.vue?vue&type=script&lang=js"
import style0 from "./SFormGroup.vue?vue&type=style&index=0&id=144e22ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports